const traductions = {

  btn_selector_ruta: {es: 'SELECCIONE RUTA', en: 'SELECT TRIP'},

  ruta_0: {es: 'MACHUPICCHU', en: 'MACHUPICCHU'},
  ruta_1: {es: 'MACHUPICCHU + MONTAÑA WAYNAPICCHU', en: 'MACHUPICCHU + WAYNAPICCHU MOUNTAIN'},
  ruta_2: {es: 'MACHUPICCHU + MONTAÑA MACHUPICCHU', en: 'MACHUPICCHU + MACHUPICCHU MOUNTAIN'},
  ruta_3: {
    es: 'Camino Inka - Rutas 01, 02 y 03',
    en: 'Inka Trail - Trip 01, 02 and 03'
  },
  ruta_4: {
    es: 'Camino Inka - Ruta 05',
    en: 'Inka Trail - Trip 05'
  },
  ruta_c5: {
    es: 'Circuito 4 + Montaña Waynapicchu',
    en: 'Circuit 4 + Waynapicchu Mountain'
  },
  ruta_c6: {
    es: 'Montaña Machupicchu + Circuito 3',
    en: 'Machupicchu Mountain + Circuit 3'
  },
  ruta_c7: {
    es: 'Circuito 4 + Montaña Huchuypicchu',
    en: 'Circuit 4 + Huchuypicchu Mountain'
  },
  ruta_c8: {
    es: 'Circuito 1, 2 + Puente Inka',
    en: 'Circuit 1, 2 + Inka Bridge'
  },

  updated: {
    es: 'Actualizado al',
    en: 'Updated at'
  },

  error_not_service: {
    es: 'Servicio no disponible',
    en: 'Service not available'
  },
  error_refresh: {
    es: 'Por favor actualice esta página en unos minutos',
    en: 'Please refresh this page in a few minutes'
  },

  select_month: { es: 'Selecciona un mes', en: 'Pick a month' },
  cancel: { es: 'Cancelar', en: 'Cancel' },

  mes_1: { es: 'Enero', en: 'January' },
  mes_2: { es: 'Febrero', en: 'February' },
  mes_3: { es: 'Marzo', en: 'March' },
  mes_4: { es: 'Abril', en: 'April' },
  mes_5: { es: 'Mayo', en: 'May' },
  mes_6: { es: 'Junio', en: 'June' },
  mes_7: { es: 'Julio', en: 'July' },
  mes_8: { es: 'Agosto', en: 'August' },
  mes_9: { es: 'Setiembre', en: 'September' },
  mes_10: { es: 'Octubre', en: 'October' },
  mes_11: { es: 'Noviembre', en: 'November' },
  mes_12: { es: 'Diciembre', en: 'December' },

  dia_1: { es: 'Lunes', en: 'Monday' },
  dia_2: { es: 'Martes', en: 'Tuesday' },
  dia_3: { es: 'Miércoles', en: 'Wednesday' },
  dia_4: { es: 'Jueves', en: 'Thursday' },
  dia_5: { es: 'Viernes', en: 'Friday' },
  dia_6: { es: 'Sábado', en: 'Saturday' },
  dia_7: { es: 'Domingo', en: 'Sunday' },

};

export function translateLang(data, lang) {

  return traductions[data][lang];

}

export function translateRoute(trip_id, lang) {

  let data;

  switch (trip_id) {
    case 0:
      data = 'ruta_0';
      break;
    case 1:
      data = 'ruta_1';
      break;
    case 2:
      data = 'ruta_2';
      break;
    case 3:
      data = 'ruta_3';
      break;
    case 4:
      data = 'ruta_4';
      break;
    case 5:
      data = 'ruta_c5';
      break;
    case 6:
      data = 'ruta_c6';
      break;
    case 7:
      data = 'ruta_c7';
      break;
    case 8:
      data = 'ruta_c8';
      break;
    default:
      data = 'ruta_0';
      break;
  }

  return traductions[data][lang];

}
